import * as React from 'react';
import { useParams } from 'react-router-dom';
import Logo from '@doordash/component-logo';
import Loading from '@doordash/component-loading';
import { Colors, InlineChildren, Spacing, StackChildren, Text, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import FullScreenLayout from '../../../core/AppLayoutV2/FullScreenLayout/full_screen_layout';
import { usePreviewVoucher } from '../../../hooks/usePreviewVoucherRedemption';
import { IMAGE_BASE_URL, DD_PRIVACY_POLICY_URL, PORTAL_ROUTE_PREFIX, DEFAULT_DEEPLINK_DDFW, DDFW_CONSUMER_TERMS_OF_SERVICE_URL, } from '../../../constants/values';
import { VoucherCard } from '../components/VoucherCard';
import { VoucherCardWrapper, LegalTermLink, ContentWrapper, } from './PreviewVoucherStyles';
import VoucherErrorPage from './VoucherErrorPage';
import VoucherStrings from '../VoucherStrings';
import track from '../../../utils/track';
import { VoucherParticipantEvents } from '../../../constants/events/names';
import { isIosDevice } from '../../../utils/mediaDevice';
var BROWSER_REDIRECT_WAIT_DURATION = 25;
var APP_REDIRECT_WAIT_DURATION = 100;
var IMG_URL = IMAGE_BASE_URL + "/p/fit=scale-down,width=1920,format=auto,quality=50/managed/consumer/teams/preview-voucher-background.png";
var PunchedHoleColor = '#ececec';
var pageStrings = VoucherStrings.previewVoucherPage;
export var PreviewVoucher = function () {
    var _a, _b, _c, _d;
    var _e = useParams(), teamAccountId = _e.teamAccountId, budgetId = _e.budgetId;
    var _f = usePreviewVoucher(budgetId, teamAccountId, false), data = _f.data, isVoucherLoading = _f.loading, error = _f.error;
    var teamName = ((_a = data === null || data === void 0 ? void 0 : data.previewVoucherRedemption) === null || _a === void 0 ? void 0 : _a.teamName) || '';
    React.useEffect(function () {
        track(VoucherParticipantEvents.PREVIEW_VOUCHER_PAGE_LOAD, {
            voucher_id: budgetId,
        });
    }, [budgetId]);
    var handleAcceptButtonClick = function () {
        var isIos = isIosDevice(navigator.userAgent);
        var fallbackAcceptVoucherUrl = "" + window.location.origin + PORTAL_ROUTE_PREFIX + "/voucher/accept/" + teamAccountId + "/budget/" + budgetId;
        var acceptVoucherDeepLink = DEFAULT_DEEPLINK_DDFW + "/voucher/accept/" + teamAccountId + "/budget/" + budgetId;
        track(VoucherParticipantEvents.PREVIEW_VOUCHER_CLICK_ACCEPT, {
            voucher_id: budgetId,
        });
        if (isIos) {
            var now_1 = new Date().valueOf();
            setTimeout(function () {
                var timeExecuted = new Date().valueOf() - now_1;
                // allow app deeplink to trigger before it attempts to do browser redirect
                if (timeExecuted > APP_REDIRECT_WAIT_DURATION) {
                    return;
                }
                window.location.href = fallbackAcceptVoucherUrl;
            }, BROWSER_REDIRECT_WAIT_DURATION);
        }
        window.location.href = isIos
            ? acceptVoucherDeepLink
            : fallbackAcceptVoucherUrl;
    };
    if (isVoucherLoading) {
        return (React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 }));
    }
    if (error || ((_b = data === null || data === void 0 ? void 0 : data.previewVoucherRedemption) === null || _b === void 0 ? void 0 : _b.error)) {
        // apollo error will be default to an unspecified error
        // because there is no response data from gql call
        return React.createElement(VoucherErrorPage, { error: (_c = data === null || data === void 0 ? void 0 : data.previewVoucherRedemption) === null || _c === void 0 ? void 0 : _c.error });
    }
    return (React.createElement(FullScreenLayout, { backgroundImgUrl: IMG_URL, logoColor: Logo.Colors.Default, logoStyles: {
            paddingTop: Spacing.XxxxLarge,
            paddingBottom: Spacing.XxLarge,
        }, justifyContent: InlineChildren.Justification.FlexStart },
        React.createElement(ContentWrapper, null,
            React.createElement(Text, { styles: Text.Styles.PageTitle2, textAlign: Text.TextAlignments.Center }, pageStrings.title(teamName)),
            React.createElement(VoucherCardWrapper, null,
                React.createElement(VoucherCard, { voucher: (_d = data === null || data === void 0 ? void 0 : data.previewVoucherRedemption) === null || _d === void 0 ? void 0 : _d.voucher, cardBackgroundColor: Colors.SystemWhite, punchedHoleColor: PunchedHoleColor })),
            React.createElement(StackChildren, null,
                React.createElement(Button, { size: Button.Sizes.Medium, onClick: handleAcceptButtonClick }, pageStrings.acceptButton()),
                React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextPrimary, textAlign: Text.TextAlignments.Center }, "By clicking \"Accept Voucher\", you agree to the ",
                    React.createElement(LegalTermLink, { href: DDFW_CONSUMER_TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer" }, pageStrings.termsAndConditionsLink()), ". See the ",
                    React.createElement(LegalTermLink, { href: DD_PRIVACY_POLICY_URL, target: "_blank", rel: "noopener noreferrer" }, pageStrings.privacyPolicyLink()),
                    '.')))));
};
export default PreviewVoucher;
